/****************************************************
 * Module Name:  labMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import LabProxy from "../../utility/proxy/manager/labProxy";
import AddLabModal from "./addLabModal";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class LabMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      labs: [],
      showAddLabModal: false,
      accesDenied: false,
      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      loadingButton: false,

      showLabLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_LAB
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("MASTER_LAB");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchLabData(false);
    }
  }


  fetchLabData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLabLoadSpinner: true });
    LabProxy.GetAllLab((responseData) => {
      if (responseData) {
        this.setState({ labs: responseData, showLabLoadSpinner: false })
      } else {
        this.setState({ errorSnackbar: true, showLabLoadSpinner: false })
      }
    }
    );
  };

  columns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
    },
    {
      field: "name",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 1.5,
      minWidth: 200,
      renderCell: renderCellExpand,
    },
    {
      field: "address",
      headerName: "ADDRESS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "pincode",
      headerName: "PINCODE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "phone",
      headerName: "PHONE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "mobile",
      headerName: "MOBILE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "fax",
      headerName: "FAX",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "webref",
      headerName: "WEB REFERENCE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "seq",
      headerName: "SEQUENCE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 50,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddLabModal: true,
                editOperation: true,
                sourceData: params.row,
                loadingButton: false,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideAddLabModal = () => {
    this.setState({
      showAddLabModal: false,
    });
  };

  handleValidation = (labData) => {
    //TODO do validation if needed here
    return true;
  };

  addLab = (labData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Lab, and once lab is updated on call refresh the list of current labs
      LabProxy.UpdateLab(labData, (response) => {
        if (response) {
          this.fetchLabData(true);
          this.hideAddLabModal();
          this.setState({ loadingButton: false });
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    } else {
      //Creating new Lab, and once lab is created on call refresh the list of current labs
      LabProxy.AddLab(labData, (response) => {
        if (response) {
          this.fetchLabData(true);
          this.hideAddLabModal();
          this.setState({ loadingButton: false });
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  render() {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.labs;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");
    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />
        {this.state.showAddLabModal ? (
          <AddLabModal
            Show={true}
            handleClose={this.hideAddLabModal}
            handleSave={this.addLab}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        <Box px={1}>
          <Box
            sx={{
              width: "100%",
              backgroundColor: '#fff',
              color: '#000',
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: GridToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              loading={this.state.showLabLoadSpinner}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
            <Box style={{ position: "absolute", top: 5, right: "270px" }}>
              {this.state.showLabLoadSpinner ? (
                <CircularProgress size="1rem" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="medium"
                    onClick={() => this.fetchLabData(true)}
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
              {Utility.isAddAllowed(this.state.local_Permission) ? (
                <Tooltip title="Add Lab">
                  <Button
                    color="info"
                    variant="outlined"
                    size="small"
                    sx={{ ml: "5px" }}
                    onClick={() =>
                      this.setState({
                        showAddLabModal: true,
                        editOperation: false,
                        sourceData: {},
                      })
                    }
                    startIcon={<AddBoxOutlinedIcon size="large" />}
                  >
                    Lab
                  </Button>
                </Tooltip>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default LabMaster;
